<template>
  <div>
    <span
      v-if="
        def.inputType &&
          def.inputType.name === 'ECore.Def.DefEnums.itMultiRadio'
      "
    >
      <AppMultiRadioButton
        disabled
        :def="def"
        :model="model"
        :items="$attrs.items"
      />
    </span>
    <div v-else :class="[$attrs.ingrid ? 'ingrid' : 'readOnly BG2']"
      :style="{ cursor: isCopyable ? 'pointer' : 'default' }" @click="handleFieldClick">
      <v-row>
        <v-col :cols="def.suffixLabel ? 9 : 12">
          <v-row
            v-if="!$attrs.ingrid"
            no-gutters
            class="readOnly__title G2--text"
          >
            <v-col cols="12">
              {{ $t(def) }}
            </v-col>
          </v-row>
          <v-row
            v-if="model[def.name] !== undefined"
            no-gutters
            :class="[$attrs.ingrid ? '' : 'mt-2' , 'readOnly__value mb-0 pb-0']"
          >
            <v-col cols="12">
              {{ displayValue(def , model[def.name]) }}
            </v-col>
          </v-row>
          <v-row v-else-if="model[def.name] === undefined">
            <v-col
              cols="12"
              class="ma-0 py-0"
            >
              -
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="def.suffixLabel"
          class="suffix mt-2 mb-0 pb-0"
          :cols="def.suffixLabel ? 3 : 0"
          style="
            color: grey;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          {{ $t(def.suffixLabel) }}
        </v-col>
      </v-row>

      <!-- پیغام کپی شدن -->
     <v-snackbar v-model="showCopyMessage" :timeout="1500" bottom right color="P1" class="copy-toast">
        <v-icon small left>
          mdi-content-copy
        </v-icon>
        {{ $t(def) }}
        کپی شد
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import jalali from "moment-jalaali";
import AppMultiRadioButton from "@/components/library/inputFields/AppMultiRadioButton";
import AbrPropDisplayValue from "@/mixins/AbrPropDisplayValue"
// import AppFileInput from "@/components/library/inputFields/AppFileInput";

export default {
  name: "AbrFormPropReadOnly",
  components: {
    AppMultiRadioButton,
  },
  mixins: [AbrPropDisplayValue],
  props: ["def", "model"],
  data() {
    return {
      showCopyMessage: false,
    };
  },
  computed: {
    textValue() {
      if (this.model && this.def && this.def.name) {
        const rawValue = this.model[this.def.name];
        if (rawValue === undefined || rawValue === null) {
          return "";
        }
        return this.displayValue(this.def, rawValue);
      }
      return "";
    },
    isCopyable() {
      if (!this.textValue || this.textValue === "-" || !!this.$attrs.ingrid) return false;

      const excludeTypes = ["itMoney", "itFile", "itMultiRadio"];
      if (this.def.inputType && this.def.inputType.name) {
        const fieldType = this.def.inputType.name.split(".").pop();
        if (excludeTypes.includes(fieldType)) return false;
      }

      return true;
    },
  },
  methods: {
    jalaliDate(payload) {
      return jalali(payload);
    },
    async handleFieldClick() {
      if (!this.isCopyable) return;

      try {
        await navigator.clipboard.writeText(this.textValue);
        this.showCopyMessage = true;
        this.$emit("copy-success", this.textValue);
      } catch (err) {
        console.error("کپی ناموفق: ", err);
        this.fallbackCopyTextToClipboard(this.textValue);
      }
    },
    fallbackCopyTextToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      this.showCopyMessage = true;
    },
  },
};
</script>

<style>

.ingrid{
  display: grid;
  align-content: center;
  /* min-height: 56px; */
  /* padding: 0 10px ; */
  box-sizing: border-box;
  margin-bottom: 2px;
}
.readOnly {
  min-height: 58px;
  padding: 0 10px;
  border: 1px solid rgba(224, 224, 224, 1);
  box-sizing: border-box;
  border-radius: 4px;
  background-color: transparent;
  /* height: 56px; */
  margin-bottom: 22px;
  transition: background-color 0.2s ease;
}

.readOnly:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
.readOnly__title {
  font-size: 10px;
  margin-top: 5px !important;
  margin-bottom: 8px;
}
.readOnly__value {
  font-size: 14px;
}
.suffix {
  font-size: 12px !important;
}

.copy-toast {
  position: fixed !important;
  z-index: 9999;
}
</style>